<template>
  <div>
    <div class="p-2 bg-white border-2 border-b-0 rounded-t gap-2 flex items-center justify-between">
      <div>
        <v-btn
          @click="toggleSelectAll"
          elevation="0"
          class="mr-2"
        >{{ $t('select_all') }}</v-btn>
        <v-btn
          class="mr-2"
          @click="isConfirm = true"
          :disabled="selected.length < 1"
          elevation="0"
          color="primary"
        >{{ $t('task.approve_count', { count: selected.length}) }}</v-btn>
        <v-btn
          class="mr-2"
          @click="isCancel = true"
          :disabled="selected.length < 1"
          elevation="0"
          color="error"
        >{{ $t('task.not_approve_count', { count: selected.length}) }}</v-btn>
      </div>
      <div>
        <v-btn icon elevation="0" color="primary" @click="onInit()">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </div>
    </div>
    <template>
      <v-data-table
        show-select
        :headers="headers"
        :items="approveTasks"
        :loading="loading || isLoading"
        :items-per-page="50"
        class="border-2"
        v-model="selected"
        @toggle-select-all="toggleSelectAll"
        item-key="objectId"
        :no-data-text="$t('task.no_send_approve_setting')"
        :no-results-text="$t('no_matching_records_found')"
      >
        <template v-slot:item.data-table-select="{ item, isSelected, select }">
          <v-simple-checkbox
            v-if="checkPermission(item.appeal.subCategory).enableEdit"
            :value="isSelected"
            @input="select($event)">
          </v-simple-checkbox>
          <v-tooltip top v-else>
            <template v-slot:activator="{ on, attrs }">
              <v-simple-checkbox
                v-bind="attrs"
                v-on="on"
                readonly
                disabled>
              </v-simple-checkbox>
            </template>
            <span>{{ $t('task.no_permission_to_approve_appeal') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.appeal="{ item }">
          {{ $t(`appeal_data.subCategory.${AppealLabels.subCategory[item.appeal.subCategory].value}`) }}
        </template>
        <template v-slot:item.createdBy="{ item }">{{ item.createdByFullName }}</template>
        <template v-slot:item.createdAt="{ item }">{{ item.createdAtDateFormat }}</template>
        <template v-slot:item.updatedBy="{ item }">{{ item.updatedByFullName }}</template>
        <template v-slot:item.updatedAt="{ item }">{{ item.updatedAtDateFormat }}</template>
        <template v-slot:item.status="{ item }">
          <div class="max-w-sm flex" style="justify-content: center;">
            <span :class="item.statusColor + ' px-3 py-1 rounded-full '">
              {{ item.statusString }}
            </span>
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="flex justify-end">
            <v-btn
              color="grey
              lighten-4"
              elevation="0"
              rounded small
              @click="onClickDetail(item)"
            >{{ $t('detail') }}</v-btn>
          </div>
        </template>
      </v-data-table>
    </template>
    <v-dialog v-model="isAppeal" max-width="900" scrollable persistent content-class="dialog-appeal">
      <v-card outlined>
        <v-card-title :class="`flex justify-between ${form.status ? AppealLabels.status[form.status].colorBg : ''}`">
          <div>{{ `${$t('appeal_data.title')} ${form.subCategory ? $t(`appeal_data.subCategory.${AppealLabels.subCategory[form.subCategory].value}`) : ''}` }}</div>
          <div v-if="AppealLabels.status[form.status]" style="display: flex; align-items: center;">
            <v-chip
              color="warning"
              v-if="form.requestData && form.requestData.statusBeforeCancelled == 'success'"
              style="margin-right:5px;"
            >{{ $t('task.appeal_approved_before') }}
            </v-chip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-chip :color="AppealLabels.status[form.status].color">
                    <span style="color:#FFF">{{ $t(`appeal_data.status.${AppealLabels.status[form.status].value}.text`) }}</span>
                  </v-chip>
                </div>
              </template>
              <div>{{ $t(`appeal_data.status.${AppealLabels.status[form.status].value}.tooltip`) }}</div>
            </v-tooltip>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="isLoadAppeal" class="flex justify-center align-center" style="height: 600px; padding:30px;">
          <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        </v-card-text>
        <v-card-text class="overflow-y-auto" style="height: 600px" v-if="!isLoadAppeal">
          <v-container>
            <v-select
              v-model="form.category"
              :items="[AppealLabels.category[form.category]]"
              item-text="text"
              item-value="value"
              :label="$t('appeal.select_appeal_category')"
              outlined :disabled="true"
              :no-data-text="$t('noinfo')"
            >
              <template v-slot:selection="{ item }">
                {{ $t(`appeal_data.category.${item.value}`) }}
              </template>
              <template v-slot:item="{ item }">
                {{ $t(`appeal_data.category.${item.value}`) }}
              </template>
            </v-select>
            <v-select
              :disabled="true"
              v-model="form.subCategory"
              :items="[AppealLabels.subCategory[form.subCategory]]"
              item-text="text"
              item-value="value"
              :label="$t('appeal.select_appeal')"
              outlined
              :no-data-text="$t('noinfo')"
            >
              <template v-slot:selection="{ item }">
                {{ $t(`appeal_data.subCategory.${item.value}`) }}
              </template>
              <template v-slot:item="{ item }">
                {{ $t(`appeal_data.subCategory.${item.value}`) }}
              </template>
            </v-select>
            <template v-if="form.subCategory == 'document_shop_certify'">
              <v-select
                v-model="form.requestData.reasonShopCertify"
                :items="AppealLabels.reasonShopCertifyItem"
                item-text="text"
                item-value="value"
                :label="$t('customer.reason_for_document')"
                outlined disabled
                :no-data-text="$t('noinfo')">
              </v-select>
              <span>{{ $t('market.start_date_business_with_market') }}</span>
              <v-menu
                ref="is_start_date_certify"
                v-model="isStartDateCertify"
                :close-on-content-click="false"
                :return-value.sync="form.requestData.startDateCertify"
                transition="scale-transition"
                offset-y
                min-width="auto" disabled
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    solo
                    flat
                    background-color="grey lighten-4"
                    :value="$helper.datelabel(form.requestData.startDateCertify)"
                    :label="$t('market.start_date_business_with_market')"
                    prepend-inner-icon="mdi-calendar"
                    readonly v-bind="attrs"
                    v-on="on"
                    disabled>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="form.requestData.startDateCertify"
                  no-title
                  scrollable
                  locale="th"
                  :header-date-format="$helper.headerDateFormat"
                  :year-format="$helper.yearFormat"
                  :weekday-format="$helper.formatWeekday"
                  :month-format="$helper.formatMonth"
                  persistent-hint
                  disabled
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="error" @click="isStartDateCertify = false">
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    text
                    color="success"
                    @click="$refs.is_start_date_certify.save(form.requestData.startDateCertify)"
                  >{{ $t('confirm') }}
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <span v-if="form.documentRunningNumber && false">{{ $t('customer.document_number')}}</span>
              <v-text-field 
                v-if="form.documentRunningNumber && false"
                flat
                background-color="grey lighten-4"
                solo
                disabled
                :value="shopCertifyNo(form)">
              </v-text-field>
            </template>
            <div v-if="form.subCategory == 'suspend_other'">
              <span>{{ $t('suspend.title_suspend_business') }}</span>
              <v-text-field
                v-model="form.requestData.otherType"
                solo
                flat
                background-color="grey lighten-4"
                :label="$t('suspend.title_suspend_business')"
                disabled>
              </v-text-field>
            </div>
            <div class="flex justify-between">
              <h4>{{ $t('appeal.appeal_reporter') }}</h4>
            </div>

            <template>
              <v-radio-group v-model="form.customerType" row hide-details class="mt-2 mb-3">
                <div class="d-flex justify-between align-center gap-2 w-100">
                  <div class="w-50">
                    <v-radio :label=" $t('appeal.customer')" value="customer" class="box-radio" disabled></v-radio>
                  </div>
                  <div class="w-50">
                    <template v-if="form.customerType != 'central'">
                      <v-tooltip top content-class="bg-grey white--text">
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            <v-radio :label="$t('appeal.central')" value="central" class="box-radio" disabled></v-radio>
                          </div>
                        </template>
                        <span>{{ $t('appeal.central_cannot_appeal') }}</span>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <v-radio :label="$t('appeal.central')" value="central" class="box-radio" disabled></v-radio>
                    </template>
                  </div>
                </div>
              </v-radio-group>
            </template>

            <template v-if="form.customerType != 'central'">
              <customer-card 
                v-if="form.customer && form.customer.profileImages"
                :emails="form.customer.emails"
                :firstName="form.customer.firstName"
                :lastName="form.customer.lastName"
                :tels="form.customer.tels"
                :interTels="form.customer.interTels"
                :companyName="form.customer.companyName"
                :type="form.customer.type"
                :img="form.customer.profileImages[0] ? form.customer.profileImages[0].url : '/user.png'"
                :url="`/project/${projectId}/market/${marketId}/customer/${form.customer.objectId}/view`">
              </customer-card>
            </template>
            <v-select
              v-if="form.customer && (form.subCategory != 'change_info_contact' && form.subCategory != 'document_shop_certify' && form.subCategory != 'renew_contract' && form.category != 'suspend') || form.customerType == 'central'"
              v-model="form.areas"
              :items="form.areas"
              :label="$t('area.select_stall')"
              outlined
              chips
              class="select-area"
              :multiple="true"
              :item-text="i => i.name" item-value="objectId"
              :no-data-text="$t('appeal.no_stall_please_select_appeal_reporter')"
              disabled>
            </v-select>
            <v-select
              v-if="form.customer && (form.subCategory == 'installment_invoice' || form.category == 'suspend' || form.subCategory == 'other')"
              v-model="form.contract"
              :items="[form.contract]"
              :label="$t('contract.select_contract')"
              outlined
              chips
              :item-text="contract => `${contract.contractId} (${contract.businessName || '-'})`"
              :item-value="contract => contract"
              :no-data-text="$t('appeal.no_rental_agreement_please_select_appeal_reporter')"
              disabled>
            </v-select>
            <template v-if="form.customer && form.subCategory == 'change_owner_contact'">
              <v-select
                v-model="form.contract"
                :items="[form.contract]"
                :item-text="contract => `${contract.contractId} ${!contract.isActive ? '(' + $t('contract.close_contract') + ')' : ''}`"
                :item-value="contract => contract"
                :label="$t('contract.select_contract')"
                :no-data-text="$t('area.no_rental_agreement')"
                outlined
                disabled
              >
                <template v-slot:selection="{ item }">
                  <div class="d-block w-100" style="width: 100%">
                    {{ `${item.contractId}` }}
                    <span 
                      class="rounded-full text-white bg-red-500 px-2 py-1 text-xs ml-2"
                      v-if="!item.isActive"
                    >{{ $t('contract.close_contract') }}
                    </span>
                  </div>
                </template>
              </v-select>
              <div class="change-old-box">
                <span>{{ $t('customer.transferor_name') }}</span>
                <div class="text-lg grey lighten-4">{{ form.customer.type == 'company' ? `${form.customer.companyName}` :
                  `${form.customer.title} ${form.customer.firstName} ${form.customer.lastName}` }}</div>
              </div>
              <span>{{ $t('customer.receiver_name') }}</span>
              <span class="color-red" v-if="!form.requestData.contractNewCustomer">{{ $t('validate.required_select') }}</span>
              <div class="change-box" style="display: flex; justify-content: flex-start;">
                <customer-card v-if="form.requestData.contractNewCustomer"
                  :emails="form.requestData.contractNewCustomer.emails"
                  :firstName="form.requestData.contractNewCustomer.firstName"
                  :lastName="form.requestData.contractNewCustomer.lastName"
                  :tels="form.requestData.contractNewCustomer.tels"
                  :interTels="form.requestData.contractNewCustomer.interTels"
                  :companyName="form.requestData.contractNewCustomer.companyName"
                  :type="form.requestData.contractNewCustomer.type"
                  :img="form.requestData.contractNewCustomer.profileImages && form.requestData.contractNewCustomer.profileImages[0] ? form.requestData.contractNewCustomer.profileImages[0].url : '/user.png'"
                  :url="`/project/${projectId}/market/${marketId}/customer/${form.requestData.contractNewCustomer.objectId}/view`"></customer-card>
              </div>

              <span>{{ $t('companion_party') }}</span>
              <v-combobox
                disabled
                flat
                background-color="grey lighten-4"
                solo
                v-model="form.requestData.relation"
                :items="[form.requestData.relation]"
                :label="$t('customer.select_relation')"
              >
                <template v-slot:selection="{ item }">
                  {{ $t(`appeal_data.relations.${item}`) }}
                </template>
                <template v-slot:item="{ item }">
                  {{ $t(`appeal_data.relations.${item}`) }}
                </template>
              </v-combobox>
              <span>{{ $t('contract.transfer_effective_date') }}</span>
              <v-chip
                color="success"
                v-if="form.status == 'success' && form.subCategory == 'change_owner_contact' && form.isEffective"
                style="margin-left:5px;"
              >{{ $t('customer.transfer_success') }}
              </v-chip>
              <v-chip
                color="warning"
                v-if="form.status == 'success' && form.subCategory == 'change_owner_contact' && !form.isEffective"
                style="margin-left:5px;"
                >{{ $t('contract.waiting_transfer') }}
              </v-chip>
              <v-radio-group
                v-model="form.effectiveByStatus"
                style="margin-top:0;"
              >
                <v-radio
                  disabled
                  :value="true"
                  color="info"
                  :label="$t('contract.effective_date_now')">
                </v-radio>
                <v-radio
                  disabled
                  :value="false"
                  color="info"
                  :label="$t('contract.effective_date_selected')">
                </v-radio>
              </v-radio-group>
              <v-menu
                v-if="!form.effectiveByStatus"
                ref="menu_effective_date"
                v-model="menuEffectiveDate"
                :close-on-content-click="false"
                :return-value.sync="form.effectiveDate_tmp"
                transition="scale-transition"
                offset-y
                min-width="auto"
                disabled
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    solo
                    flat
                    background-color="grey lighten-4"
                    :value="$helper.datelabel(form.effectiveDate_tmp)"
                    :label="$t('customer.effective_date')"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    disabled>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="form.effectiveDate_tmp"
                  no-title
                  scrollable locale="th"
                  :header-date-format="$helper.headerDateFormat"
                  :year-format="$helper.yearFormat"
                  :weekday-format="$helper.formatWeekday"
                  :month-format="$helper.formatMonth"
                  :min="$moment().add(1, 'days').format('YYYY-MM-DD')"
                  persistent-hint disabled
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="error"
                    @click="menuEffectiveDate = false"
                  >{{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    text
                    color="success"
                    @click="$refs.menu_effective_date.save(form.effectiveDate_tmp)"
                  >{{ $t('confirm') }}
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </template>

            <div v-if="form.subCategory == 'change_info_contact' && form.customer">
              <div class="change-old-box">
                <span>
                  {{ form.customer.type == 'company' ? $t('customer.company_name_title') : $t('name_surname') }}
                  <u>
                    <b>{{ $t('old') }}</b>
                  </u>
                </span>
                <div class="text-lg grey lighten-4 p-2 px-3">
                  {{ form.customer.type == 'company' ?
                  form.requestData.oldCompanyName : `${form.requestData.oldPrefixName}${form.requestData.oldFirstName}
                  ${form.requestData.oldLastName}` }}
                </div>
              </div>
              <span>
                {{ form.customer.type == 'company' ? $t('customer.company_name_title') : $t('name_surname') }}
                <u>
                  <b>{{ $t('new') }}</b>
                </u>
              </span>
              <div class="change-box" v-if="form.customer.type == 'company'">
                <span>{{ $t('customer.company_name_title') }}</span>
                <v-text-field
                  disabled
                  flat
                  background-color="grey lighten-4"
                  solo :label="$t('customer.company_name_title')"
                  v-model="form.requestData.companyName">
                </v-text-field>
              </div>
              <div class="grid grid-cols-5 gap-2 change-box" v-else>
                <div>
                  <span>{{ $t('account.prefix') }}</span>
                  <v-combobox
                    disabled
                    flat
                    background-color="grey lighten-4"
                    solo
                    v-model="form.requestData.prefixName"
                    :items="[form.requestData.prefixName]"
                    :label="$t('account.prefix')">
                  </v-combobox>
                </div>
                <div class="col-span-2">
                  <span>{{ $t('account.first_name') }}</span>
                  <v-text-field
                    disabled
                    flat
                    background-color="grey lighten-4"
                    solo
                    :label="$t('account.first_name')"
                    v-model="form.requestData.firstName">
                  </v-text-field>
                </div>
                <div class="col-span-2">
                  <span>{{ $t('account.last_name') }}</span>
                  <v-text-field
                    disabled
                    flat
                    background-color="grey lighten-4"
                    solo
                    :label="$t('account.last_name')"
                    v-model="form.requestData.lastName">
                  </v-text-field>
                </div>
              </div>
              <div class="change-box">
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>
                      {{ form.customer.type == 'company' ? $t('customer.company_document') : $t('customer.citizen_card_images') }}
                      <u>
                        <b>{{ $t('old') }}</b>
                      </u>
                    </span>
                    <template v-if="form.requestData.oldCitizenCardImages">
                      <v-card outlined v-for="(citizen, index) of form.requestData.oldCitizenCardImages"
                        :key="`citizenxx_${index}`" class="mb-2">
                        <v-card-text class="relative" style="padding:0;">
                          <div class="d-flex justify-space-between w-100 bg-gray-100">
                            <img :src="citizen.url" style="width:auto;height:100px;margin:0 auto;" />
                          </div>
                        </v-card-text>
                      </v-card>
                    </template>
                    <div v-else>{{ $t('not_specified') }}</div>
                  </div>
                  <div>
                    <span>
                      {{ form.customer.type == 'company' ? $t('customer.company_document') : $t('customer.citizen_card_images') }}
                      <u>
                        <b>{{ $t('new') }}</b>
                      </u>
                    </span>
                    <v-card outlined v-for="(citizen, index) of form.requestData.citizenCardImages"
                      :key="`citizenxx_${index}`" class="mb-2">
                      <v-card-text class="relative" style="padding:0;">
                        <div class="d-flex justify-space-between w-100 bg-gray-100">
                          <img :src="citizen.url" style="width:auto;height:100px;margin:0 auto;" />
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="form.subCategory == 'installment_invoice' && form.customer && form.areas"
              style="margin-bottom:20px;">
              <v-select
                :label="$t('invoice.select_invoice_to_adjust')"
                :no-data-text="$t('invoice.no_invoice_to_adjust')"
                outlined
                chips
                :items="[form.requestData.installmentInvoiceObject]"
                disabled
                item-value="objectId"
                v-model="form.requestData.installmentInvoiceObject"
              >
                <template v-slot:selection="{ item }">
                  {{ `${item.documentId}` }}
                  ({{ `${item.documentTypeString}` }})
                  <div class="m-2">{{ $t('net_amount') }}</div>
                  <div class="text-xl">
                    {{ item.totalValue | currency }}
                    <span class="text-lg">{{ $helper.currencySign() }}</span>
                  </div>
                </template>
                <template v-slot:item="{ item }">
                  {{ `${item.documentId}` }}
                  ({{ `${item.documentTypeString}` }})
                  <div class="m-2">{{ $t('net_amount') }}</div>
                  <div class="text-xl">
                    {{ item.totalValue | currency }}
                    <span class="text-lg">{{ $helper.currencySign() }}</span>
                  </div>
                </template>
              </v-select>

              <v-select
                v-if="form.requestData.installmentInvoice"
                :label="$t('invoice.select_installment_period')"
                :no-data-text="$t('invoice.no_installment_period')"
                :items="[form.requestData.installmentAmount]"
                :item-value="amount => amount" v-model="form.requestData.installmentAmount"
                outlined
                disabled
              >
                <template v-slot:selection="{ item }">
                  {{ `${$t('invoice.installment_period_message', { item: item })}` }}
                </template>
                <template v-slot:item="{ item }">
                  {{ `${item} ${$t('invoice.installment_period')}` }}
                </template>
              </v-select>

              <div v-if="form.requestData.installmentAmount">
                <div class="flex justify-between">
                  <h3>{{ $t('invoice.installment_table') }}</h3>
                </div>
                <v-row>
                  <v-col cols="1" class="text-center">{{ $t('invoice.installment_period_at') }}</v-col>
                  <v-col cols="6" class="text-center">{{ $t('invoice.installment_due_date') }}</v-col>
                  <v-col cols="5" class="text-right">{{ $t('invoice.installment_total_amount') }} ({{ $helper.currencyThEn() }})</v-col>
                </v-row>
                <v-row v-for="(item, index) in form.requestData.dataInstallmentTable" :key="index"
                  class="row-installment">
                  <v-col cols="1" class="text-center text-xl">{{ item.amount }}</v-col>
                  <v-col cols="6">
                    <v-menu
                      ref="menu_due_date"
                      v-model="item.isDateMenu"
                      :close-on-content-click="false"
                      :return-value.sync="item.dueDate"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                      disabled
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field solo flat background-color="grey lighten-4" :value="$helper.datelabel(item.dueDate)"
                          :label="$t('invoice.installment_due_date')" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                          v-on="on"></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="item.dueDate"
                        no-title
                        scrollable
                        locale="th"
                        :header-date-format="$helper.headerDateFormat"
                        :year-format="$helper.yearFormat"
                        :weekday-format="$helper.formatWeekday"
                        :month-format="$helper.formatMonth"
                        :min="$moment().format('YYYY-MM-DD')"
                        persistent-hint
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="error"
                          @click="item.isDateMenu = false"
                        >{{ $t('cancel') }}</v-btn>
                        <v-btn
                          text
                          color="success"
                          @click="$refs.menu_due_date[index].save(item.dueDate)"
                        >{{ $t('confirm') }}</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      type="Number"
                      flat
                      background-color="grey lighten-4"
                      solo
                      :label="$t('bill.amount')"
                      v-model="item.totalValue"
                      class="input-right"
                      disabled>
                    </v-text-field>
                  </v-col>
                </v-row>
              </div>
            </div>

            <div v-if="form.subCategory == 'change_product_contact'" class="product-in-areas-box-list">
              <div class="product-in-areas-box-header">{{ $t('product.product_list') }}</div>
              <div class="product-in-areas-box">
                <div v-for="(currentAreaObject, areaObjectIndex) in form.requestData.areaProducts"
                  :key="currentAreaObject.objectId" class="product-in-areas-items">
                  <div class="product-in-areas-item-header text-gray-400">
                    {{ $t('product.product_to_sell_in_market', { count: currentAreaObject.name }) }}
                    <u>
                      <b>{{ $t('old') }}</b>
                    </u>
                  </div>
                  <v-chip disabled v-for="product of currentAreaObject.products" class="m-1"
                    :key="`old-${currentAreaObject.objectId}-${product.objectId}`">{{ product.name }}</v-chip>
                  <div class="no-data" v-if="currentAreaObject.products.length == 0">
                    {{ $t('product.no_product_in_market') }}
                  </div>
                  <div class="product-in-areas-item-header">
                    {{ $t('product.product_to_sell_in_market', { count: currentAreaObject.name }) }}
                    <u>
                      <b>{{ $t('new') }}</b>
                    </u>
                  </div>
                  <div class="flex justify-space-between">
                    <div v-if="currentAreaObject.newProducts && currentAreaObject.newProducts.length">
                      <v-chip v-for="(product, productIndex) in currentAreaObject.newProducts"
                        :key="'product-' + productIndex" class="m-1">{{ product.name }}</v-chip>
                    </div>
                    <div v-else class="no-data">{{ $t('product.no_add_product_in_market') }}</div>

                  </div>
                </div>
              </div>
            </div>

            <template v-if="form.subCategory == 'change_info_contact' || form.subCategory == 'document_shop_certify'">
              <div class="flex justify-between">
                <h3>{{ $t('invoice.title') }}</h3>
              </div>
              <div>
                <div class="change-box" style="text-align: end;">
                  <div v-for="(invoice, index) in form.invoices" :key="index">
                    <v-card class="invoice-card">
                      <v-card-text class="flex justify-between">
                        <div>
                          <b>{{ $t('invoice.invoice_other_bill') }} {{ invoice.totalValue | currencySuffixTextThEn(invoice.currencyCode) }}</b>
                          <v-chip style="margin-left:10px;" class="red--text" color="rgb(248,218,218)"
                            v-if="statusInvoice(invoice) == $t('payment.pending')">{{ statusInvoice(invoice) }}</v-chip>
                          <v-chip style="margin-left:10px;" class="grey--text" color="rgb(240,242,246)"
                            v-if="statusInvoice(invoice) == $t('payment.wait_approval')">{{ statusInvoice(invoice) }}</v-chip>
                          <v-chip style="margin-left:10px;" class="green--text" color="rgb(209,242,225)"
                            v-if="statusInvoice(invoice) == $t('payment.already_paid')">{{ statusInvoice(invoice) }}</v-chip>
                          <v-chip style="margin-left:10px;" class="orange--text" color="rgb(241,151,50,0.2)"
                            v-if="statusInvoice(invoice) == $t('bill.edit_bill')">{{ statusInvoice(invoice) }}</v-chip>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="form.subCategory == 'renew_contract'">
              <div v-if="form.renewOldContract"
                :class="`renew-contract-box ${form.isEffective || !form.renewNewContract ? 'new-now' : ''}`">
                <div class="col-1 sub-title">
                  <div class="mr-2">{{ $t('contract.rental_contract') }}</div>
                  <v-chip color="success">
                    <span>{{ $t('in_use') }}</span>
                  </v-chip>
                </div>
                <div class="col-3">
                  <span>{{ $t('contract.contract_id') }}</span>
                  <div class="input-slot"> {{ form.renewOldContract.contractId }} </div>
                </div>
                <div class="col-3">
                  <span>{{ $t('contract.start_date') }}</span>
                  <div class="input-slot"> {{ form.renewOldContract.startDateFormat }} </div>
                </div>
                <div class="col-3">
                  <span>{{ $t('contract.end_date') }}</span>
                  <div class="input-slot"> {{ form.renewOldContract.endDateFormat }} </div>
                </div>
                <div class="col-1">
                  <CardContractDocument v-for="(doc, index) of form.renewOldContract.contractDocument"
                    :key="`doc_old_${index}`" :indexNumber="`${index + 1}`" :object="doc"
                    @onView="contractDocumentDialog(doc, form.renewOldContract.objectId)" :isDisabled="true" />
                  <CardContractDocument v-if="form.renewOldContract.contractDocument.length < 1" :isNull="true" />
                </div>
              </div>
              <div v-if="form.renewNewContract" :class="`renew-contract-box ${form.isEffective ? '' : 'new'}`">
                <div class="col-1 sub-title">
                  <div class="mr-2">{{ $t('contract.rental_contract') }} <span v-if="form.isEffective"><u>{{ $t('old') }}</u></span> <span
                      v-else><u>{{ $t('advance') }}</u></span></div>
                  <v-chip color="warning" v-if="!form.isEffective">
                    <span>{{ $t('contract.effective_date_at', { date: form.renewOldContract.renewEffectiveDateFormat }) }}</span>
                  </v-chip>

                </div>
                <div class="col-3">
                  <span>{{ $t('contract.advance_contract_id') }}</span>
                  <div class="input-slot"> {{ form.renewNewContract.contractId }} </div>
                </div>
                <div class="col-3">
                  <span>{{ $t('contract.start_date') }}</span>
                  <div class="input-slot"> {{ form.renewNewContract.startDateFormat }} </div>
                </div>
                <div class="col-3">
                  <span>{{ $t('contract.end_date') }}</span>
                  <div class="input-slot"> {{ form.renewNewContract.endDateFormat }} </div>
                </div>
                <div class="col-1">
                  <CardContractDocument v-for="(doc, index) of form.renewNewContract.contractDocument"
                    :key="`doc_new_${index}`" :indexNumber="`${index + 1}`" :object="doc"
                    @onView="contractDocumentDialog(doc, form.renewOldContract.objectId)" :isDisabled="true" />
                  <CardContractDocument v-if="form.renewNewContract.contractDocument.length < 1" :isNull="true" />
                </div>
              </div>
              <div v-if="!form.renewNewContract" :class="`renew-contract-box`">
                <div class="col-1 sub-title">
                  <div class="mr-2">{{ $t('contract.rental_contract') }} <u>{{ $t('draft') }}</u></div>
                  <v-chip color="warning" v-if="!form.isEffective">
                    <span>{{ $t('contract.effective_date_at', { date: form.renewEffectiveDateFormat || '-' }) }}</span>
                  </v-chip>

                </div>
                <div class="col-3">
                  <span>{{ $t('contract.advance_contract_id') }}</span>
                  <div class="input-slot"> - </div>
                </div>
                <div class="col-3">
                  <span>{{ $t('contract.start_date') }}</span>
                  <div class="input-slot"> {{ form.startDateFormat }} </div>
                </div>
                <div class="col-3">
                  <span>{{ $t('contract.end_date') }}</span>
                  <div class="input-slot"> {{ form.endDateFormat }} </div>
                </div>
                <div class="col-1">
                  <template v-if="form.documents && form.documents.length > 0">
                    <CardContractDocument v-for="(doc, index) of form.documents" :key="`doc_new_${index}`"
                      :indexNumber="`${index + 1}`" :object="doc" @onView="tempContractsDocumentDialog(doc, true)"
                      :isDisabled="true" :isDisableClick="true" />
                  </template>
                  <CardContractDocument v-else :isNull="true" />
                </div>
              </div>
            </template>

            <template
              v-else-if="form.contracts && form.invoices && form.contracts.length && form.invoices.length && filterContractBySelectArea.length">
              <div class="flex justify-between">
                <h3>{{ $t('invoice.title') }}</h3>
              </div>
              <div v-for="(contract, index) in filterContractBySelectArea" :key="index">
                <span>{{ $t('contract.invoice_in_contract_at', { count: contract.contractId }) }}</span>
                <div class="change-box" style="text-align: end;">
                  <div v-for="(invoice, index) in form.invoices" :key="index">
                    <v-card v-if="invoice.contract.objectId == contract.objectId" class="invoice-card">
                      <v-card-text class="flex justify-between">
                        <div>
                          <b>{{ $t('invoice.invoice_other_bill') }} {{ invoice.totalValue | currencySuffixTextThEn(invoice.currencyCode) }}</b>
                          <v-chip style="margin-left:10px;" class="red--text" color="rgb(248,218,218)"
                            v-if="statusInvoice(invoice) == $t('payment.pending')">{{ statusInvoice(invoice) }}</v-chip>
                          <v-chip style="margin-left:10px;" class="grey--text" color="rgb(240,242,246)"
                            v-if="statusInvoice(invoice) == $t('payment.wait_approval')">{{ statusInvoice(invoice) }}</v-chip>
                          <v-chip style="margin-left:10px;" class="green--text" color="rgb(209,242,225)"
                            v-if="statusInvoice(invoice) == $t('payment.already_paid')">{{ statusInvoice(invoice) }}</v-chip>
                          <v-chip style="margin-left:10px;" class="orange--text" color="rgb(241,151,50,0.2)"
                            v-if="statusInvoice(invoice) == $t('bill.edit_bill')">{{ statusInvoice(invoice) }}</v-chip>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </div>
              </div>
            </template>
            <div v-if="form.subCategory && form.category == 'suspend'">
              <div class="mt-2">
                <div>
                  <span>{{ $t('operation_date') }}</span>
                  <v-menu
                    ref="issueDate"
                    v-model="issueDatePicker"
                    :close-on-content-click="false"
                    :return-value.sync="form.requestData.issueDate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    disabled
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        disabled
                        :value="$helper.datelabel(form.requestData.issueDate)"
                        :label="$t('start_date')"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        solo
                        flat
                        background-color="grey lighten-4"
                        v-bind="attrs"
                        v-on="on"
                        hide-details>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      locale="th"
                      v-model="form.requestData.issueDate"
                      no-title
                      :header-date-format="$helper.headerDateFormat"
                      :year-format="$helper.yearFormat"
                      :weekday-format="$helper.formatWeekday"
                      :month-format="$helper.formatMonth"
                      scrollable
                      disabled
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="error"
                        @click="issueDatePicker = false"
                      >{{ $t('cancel') }}
                      </v-btn>
                      <v-btn
                        text
                        color="success"
                        @click="$refs.issueDate.save(form.requestData.issueDate);"
                      >{{ $t('ok') }}
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
                <!-- <span>พักแผงค้า/พักการขาย</span> -->
                <div class="change-box mt-4">
                  <v-checkbox
                    class="mt-0"
                    :label="$t('suspend.suspend_stall')"
                    v-model="form.requestData.isSuspend"
                    disabled
                    hide-details>
                  </v-checkbox>
                  <v-row class="px-0 mt-4" v-if="form.requestData.isSuspend">
                    <v-col cols="4" class="pt-0">
                      <span>{{ $t('start_date') }}</span>
                      <v-menu
                        ref="startDate"
                        v-model="startDatePicker"
                        :close-on-content-click="false"
                        :return-value.sync="form.requestData.startDate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto" 
                        disabled
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field disabled :value="$helper.datelabel(form.requestData.startDate)"
                            :label="$t('start_date')" prepend-inner-icon="mdi-calendar" readonly solo flat
                            background-color="grey lighten-4" v-bind="attrs" v-on="on" hide-details></v-text-field>
                        </template>
                        <v-date-picker
                          locale="th"
                          v-model="form.requestData.startDate"
                          no-title
                          :header-date-format="$helper.headerDateFormat"
                          :year-format="$helper.yearFormat"
                          :weekday-format="$helper.formatWeekday"
                          :month-format="$helper.formatMonth"
                          scrollable
                          disabled
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="error"
                            @click="startDatePicker = false"
                          >{{ $t('cancel') }}
                          </v-btn>
                          <v-btn
                            text
                            color="success"
                            @click="$refs.startDate.save(form.requestData.startDate); editEndDate()"
                          >{{ $t('ok') }}
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="4" class="pt-0">
                      <span>{{ $t('end_date') }}</span>
                      <v-menu
                        ref="endDate"
                        v-model="endDatePicker"
                        :close-on-content-click="false"
                        :return-value.sync="form.requestData.endDate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        disabled
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            disabled
                            :value="$helper.datelabel(form.requestData.endDate)"
                            :label="$t('end_date')"
                            readonly
                            prepend-inner-icon="mdi-calendar"
                            solo
                            flat
                            background-color="grey lighten-4"
                            v-bind="attrs"
                            v-on="on"
                            hide-details>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          locale="th"
                          v-model="form.requestData.endDate"
                          no-title scrollable
                          :header-date-format="$helper.headerDateFormat"
                          :year-format="$helper.yearFormat"
                          :weekday-format="$helper.formatWeekday"
                          :month-format="$helper.formatMonth"
                          disabled
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="error"
                            @click="endDatePicker = false"
                          >{{ $t('cancel') }}
                          </v-btn>
                          <v-btn
                            text
                            color="success"
                            @click="$refs.endDate.save(form.requestData.endDate); editEndDate()"
                          >{{ $t('ok') }}
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="4" class="pt-6 d-flex align-center">
                      <v-currency-field
                        disabled
                        v-model="form.requestData.suspendDays"
                        @input="editSuspendDays"
                        :label="$t('duration_day')"
                        outlined
                        rounded
                        dense
                        background-color="grey lighten-4"
                        :messages="dayMonthYearText()"
                        :isDisabledDecimal="true"
                      />
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div v-if="form.detail" class="mt-5">
                <span>{{ $t('appeal.detail_optional') }}</span>
                <div class="change-box">
                  <v-textarea
                    auto-grow
                    disabled
                    flat
                    background-color="grey lighten-4"
                    solo
                    v-model="form.requestData.detail"
                    rows="2"
                    hide-details>
                  </v-textarea>
                </div>
              </div>
              <div v-if="form.penaltyDetail" class="mt-5">
                <span>{{ $t('appeal.penalty_detail_optional') }}</span>
                <div class="change-box">
                  <v-textarea
                    auto-grow
                    disabled
                    flat
                    background-color="grey lighten-4"
                    solo
                    v-model="form.requestData.penaltyDetail"
                    rows="2"
                    hide-details>
                  </v-textarea>
                </div>
              </div>
            </div>
            <div v-if="form.description" class="mt-5">
              <span>{{ $t('detail') }} ({{ $t('optional') }})</span>
              <div class="change-box">
                <v-textarea
                  auto-grow
                  disabled
                  flat
                  background-color="grey lighten-4"
                  solo v-model="form.description">
                </v-textarea>
              </div>
            </div>
            <div v-if="form.images && form.images.length" class="mt-5">
              <span>{{ $t('image_or_document') }}</span>
              <div class="change-box">
                <div class="grid grid-cols-2 gap-2">
                  <v-card v-for="(appealImage, index) of form.images" :key="`appealxx_${index}`" flat outlined>
                    <v-card-text class="relative" style="padding:0;">
                      <div class="d-flex justify-space-between w-100 bg-gray-100"
                        :id="`image-upload-images_tmp-${index}`">
                        <img @error="imageError(`image-upload-images_tmp-${index}`)" :src="appealImage.url"
                          style="width:auto;height:100px;margin:0 auto;" />
                        <div class="absolute right-1 top-1 grid">
                          <v-btn color="info" small elevation="0" target="_blank" :href="appealImage.url" icon>
                            <v-icon>mdi-download-circle-outline</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </div>
            <div class="mt-5">
              <!-- <div>สร้างคำร้องเมื่อ : {{ momentToDate(form.createdAt) }}</div>
              <div>สร้างคำร้องโดย : {{ fullName(form.createdBy) }}</div>
              <div>แก้ไข/เปลี่ยนสถานะ ล่าสุดเมื่อ : {{ momentToDate(form.updatedAt) }}</div>
              <div>แก้ไข/เปลี่ยนสถานะ ล่าสุดโดย : {{ fullName(form.updatedBy) }}</div>
              <div>วันเสร็จสิ้นคำร้อง : {{ form.updatedBy && form.status != 'waiting' ? momentToDate(form.updatedAt) : '-' }}
              </div> -->
              <div>{{ $t('created_at') }} : {{ momentToDate(form.createdAt) }}</div>
              <div>{{ $t('created_by') }} : {{ fullName(form.createdBy) }}</div>
              <div
                v-if="form.statusPendingAt && momentToDate(form.statusPendingAt, 'datetimesec') != momentToDate(form.statusApprovedAt, 'datetimesec')">
                {{ $t('appeal.send_appeal_at', { date: momentToDate(form.statusPendingAt) }) }}
              </div>
              <div
                v-if="form.statusPendingBy && momentToDate(form.statusPendingAt, 'datetimesec') != momentToDate(form.statusApprovedAt, 'datetimesec')">
                {{ $t('appeal.send_appeal_by', { name: fullName(form.statusPendingBy) }) }}
              </div>
              <div v-if="form.statusApprovedAt">
                {{ $t('task.approve_at', { date: momentToDate(form.statusApprovedAt) }) }}
              </div>
              <div v-if="form.statusApprovedBy">
                {{ $t('task.approve_by', { name: fullName(form.statusApprovedBy) }) }}
              </div>
              <div v-if="form.statusSuccessAt">
                {{ $t('project.finish_at', { date: momentToDate(form.statusSuccessAt) }) }}
              </div>
              <div v-if="form.statusSuccessBy">
                {{ $t('project.finish_by', { name: fullName(form.statusSuccessBy) }) }}
              </div>
              <div v-if="form.statusCancelledAt">
                {{ $t('project.cancel_at', { date: momentToDate(form.statusCancelledAt) }) }}
              </div>
              <div v-if="form.statusCancelledBy">
                {{ $t('project.cancel_by', { name: fullName(form.statusCancelledBy) }) }}
              </div>
            </div>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-2">
          <v-btn
            color="black"
            elevation="1"
            outlined
            large
            @click="isAppeal = false"
            :disabled="isLoading"
            :loading="isLoading"
          >{{ $t('close') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="!checkPermission(form.subCategory).enableEdit ? attrs : null"
                v-on="!checkPermission(form.subCategory).enableEdit ? on : null">
                <v-btn
                  color="error"
                  @click.stop="isNotApprove = true"
                  :loading="isLoading"
                  class="me-2"
                  :disabled="!checkPermission(form.subCategory).enableEdit || isLoadAppeal"
                >
                  <v-icon left>mdi-window-close</v-icon>
                  {{ $t('task.not_approve_this_appeal') }}
                </v-btn>

                <v-btn
                  color="success"
                  @click="approveConfirmIn"
                  :loading="isLoading"
                  :disabled="!checkPermission(form.subCategory).enableEdit || isLoadAppeal"
                >
                  <v-icon left>mdi-circle-outline</v-icon>
                  {{ $t('task.approve_this_appeal') }}
                </v-btn>
              </div>
            </template>
            <span>{{$t('task.no_permission_to_approve_appeal')}}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ContractDocument v-model="isContractDocument" :projectId="projectId" :marketId="marketId"
      :contract-id="contractId || null" :isUpdate="true" :object-id="contractDocumentId" :isDisable="true" />
    <ContractsDocument v-model="isTempContractDocument" :projectId="projectId" :marketId="marketId" :isDisable="true"
      :document="contractDocument" />
    <ConfirmDialog
      v-model="isConfirm"
      :title="`${$t('task.approve')}`"
      :text="`${$t('task.you_want_to_approve_setting', { count: selected.length })}`"
      :isNote="false"
      :textBtnOk="$t('confirm')"
      :textBtnCancel="$t('cancel')"
      type="success"
      @onOk="approveConfirm" />
    <ConfirmDialog
      v-model="isCancel"
      :title="`${$t('task.not_approve')}`"
      :text="`${$t('task.you_want_to_not_approve_setting', { count: selected.length })}`"
      :isNote="true"
      :textBtnOk="$t('confirm')"
      :textBtnCancel="$t('cancel')"
      type="error"
      @onOk="rejectConfirm" />
    <ConfirmDialog
      v-model="isNotApprove"
      :title="`${$t('task.not_approve')}`"
      :text="`${$t('task.you_want_to_not_approve')}`"
      :isNote="true"
      :textBtnOk="$t('confirm')"
      :textBtnCancel="$t('cancel')"
      type="error"
      @onOk="rejectConfirmIn" />
  </div>
</template>


<script>
import CustomerCard from "../components/CustomerCard.vue";
import AppealLabels from "../json/appeal-data.json";
import { ExportSettingTask } from "../exports";
import Approve from "./Approve.vue";
import { mapGetters, mapActions } from "vuex";
import { Appeal } from "../classes";
import CardContractDocument from "./CardContractDocument.vue";
import ContractsDocument from "./ContractsDocument.vue";
import ContractDocument from "./ContractDocument.vue";
import ConfirmDialog from "./ConfirmDialog.component";
export default {
  components: {
    CustomerCard,
    Approve,
    CardContractDocument,
    ContractsDocument,
    ContractDocument,
    ConfirmDialog
  },
  data() {
    return {
      AppealLabels,
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      isInterest: false,
      interestId: null,
      approveId: null,
      isConfirm: false,
      isApprove: false,
      isCancel: false,
      isAppeal: false,
      isStartDateCertify: false,
      currentSettingTasks: [],
      currentApproveTask: null,
      isLoadAppeal: false,
      isLoadContractDocument: false,
      isContractDocument: false,
      contractId: '',
      contractDocumentId: '',
      closeConfirm: false,
      contractAreas: [],
      contractDocument: null,
      isTempContractDocument: false,
      headers: [
        {
          text: this.$t('appeal.appeal_name'),
          align: "center",
          sortable: false,
          value: "appeal",
          width: "220px"
        },
        {
          align: "center",
          value: "createdBy",
          text: this.$t('created_by')
        },
        {
          align: "center",
          value: "createdAt",
          text: this.$t('created_at')
        },
        {
          align: "center",
          value: "updatedBy",
          text: this.$t('project.change_status_by', { name: '' })
        },
        {
          align: "center",
          value: "updatedAt",
          text: this.$t('project.change_status_at', { date: '' })
        },
        {
          width: "120px",
          text: this.$t('status'),
          align: "center",
          sortable: false,
          value: "status"
        },
        {
          width: "120px",
          text: "",
          align: "left",
          sortable: false,
          value: "actions"
        }
      ],
      settingTaskHeaders: [
        {
          align: "center",
          value: "name",
          text: this.$t('area.area_name')
        },
        {
          align: "center",
          value: "action",
          text: this.$t('market.action'),
          width: "180px"
        },
        {
          align: "center",
          value: "previousAccountingProduct",
          text: this.$t('payment.original_list')
        },
        {
          align: "center",
          value: "currentAccountingProduct",
          text: this.$t('payment.new_list')
        },
        {
          align: "center",
          value: "previousPrice",
          text: this.$t('payment.original_price')
        },
        {
          align: "center",
          value: "currentPrice",
          text: this.$t('payment.new_price')
        },
        {
          align: "center",
          value: "previousOriginalDiscount",
          text: this.$t('payment.original_discount')
        },
        {
          align: "center",
          value: "currentOriginalDiscount",
          text: this.$t('payment.new_discount')
        },
        {
          align: "center",
          value: "diffPrice",
          text: ""
        },
        {
          align: "center",
          value: "previousType",
          text: this.$t('payment.original_method')
        },
        {
          align: "center",
          value: "currentType",
          text: this.$t('payment.new_method')
        },
        {
          align: "center",
          value: "createdBy",
          text: this.$t('created_by')
        },
        {
          align: "center",
          value: "createdAt",
          text: this.$t('created_at')
        },
        {
          align: "center",
          value: "updatedBy",
          text: this.$t('project.change_status_by', { name: '' })
        },
        {
          align: "center",
          value: "updatedAt",
          text: this.$t('project.change_status_at', { date: '' })
        },
        {
          align: "center",
          value: "status",
          text: this.$t('status')
        }
      ],
      items: [],
      selected: [],
      isLoading: false,
      form: {},
      mode: "update",
      issueDatePicker: false,
      startDatePicker: false,
      endDatePicker: false,
      menuEffectiveDate: false,
      isNotApprove: false,
      canceledNote: '',
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    approveTasks: Array
  },
  watch: {
    approveTasks() { }
  },
  created() {
    this.prepareLabel();
  },
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
    ...mapGetters({
      marketName: "markets/getMarketName"
    }),
    filterContractBySelectArea() {
      let data = [];
      if (
        this.form.contracts &&
        this.form.contracts.length &&
        this.form.areas &&
        this.form.areas.length &&
        this.form.subCategory != "change_owner_contact" &&
        this.form.subCategory != "installment_invoice"
      ) {
        for (const contract of this.form.contracts) {
          let resIn;
          if (this.form.areas[0].objectId) {
            const resAreas = this.form.areas
              .filter(res => res.objectId)
              .map(ele => ele.objectId);
            resIn = contract.areas.filter(area =>
              resAreas.includes(area.objectId)
            );
          } else if (contract.areas) {
            resIn = contract.areas.filter(area =>
              this.form.areas.includes(area.objectId)
            );
          }
          if (resIn && resIn.length) {
            data.push(contract);
          }
        }
      } else if (
        (
          this.form.subCategory == "change_owner_contact" ||
          this.form.subCategory == "installment_invoice" ||
          this.form.subCategory == "other"
        ) && this.form.contract
      ) {
        this.form.areas = this.form.contract.areas;
        data.push(this.form.contract);
      }
      return data;
    }
  },
  methods: {
    ...mapActions({
      getContractDocuments: 'contractDocument/getContractDocuments',
      removeContractDocument: 'contractDocument/removeContractDocument'
    }),
    onInit() {
      this.$emit("onInit");
    },
    prepareLabel() {
      this.categoryItem = [];
      this.subCategoryLabel = [];
      this.filterItem = [{ value: "all", text: this.$t('all') }];
      this.prefixName = this.AppealLabels.prefixName;
      this.relationsLabel = this.AppealLabels.relations;
      this.installmentAmountItem = this.AppealLabels.installmentAmountItem;
      for (const idx in this.AppealLabels.category) {
        let category = this.AppealLabels.category[idx];
        this.categoryItem.push(category);
        this.filterItem.push(category);
      }
      for (const idx in this.AppealLabels.subCategory) {
        let subCategory = this.AppealLabels.subCategory[idx];
        this.subCategoryLabel.push(subCategory);
      }
    },
    async onClickDetail(approveTask) {
      this.isAppeal = true;
      this.isLoadAppeal = true;
      this.currentSettingTasks = [];
      this.currentApproveTask = approveTask;
      if (approveTask.appeal) this.currentSettingTasks = new Appeal(approveTask.appeal)
      this.form = Object.assign({}, this.currentSettingTasks);
      this.form.status_tmp = this.form.status;
      if (this.form.subCategory == "change_owner_contact" || this.form.category == "suspend" || this.form.subCategory == "other") {
        this.form.contract = this.form.contracts[0];
      }
      if (this.form.effectiveDate) {
        this.form.effectiveDate_tmp = this.$moment(
          this.form.effectiveDate.iso
        ).format("YYYY-MM-DD");
      }
      if (this.form.subCategory == "installment_invoice") {
        this.form.contract = this.form.contracts[0];
        await this.getInvoiceById(this.form.requestData.installmentInvoice);
      }
      if (this.form.subCategory == "renew_contract") {
        if (this.form.renewNewContract) this.form.renewNewContract.contractDocument = await this.loadContractDocuments(this.form.renewNewContract.objectId)
        if (this.form.renewOldContract) this.form.renewOldContract.contractDocument = await this.loadContractDocuments(this.form.renewOldContract.objectId)
      }
      await this.getContractsByCustomer();
      this.isLoadAppeal = false;
    },
    toggleSelectAll() {
      if (this.selected.length == this.approveTasks.length) {
        this.selected = [];
      } else {
        this.selected = this.approveTasks.filter(d => this.checkPermission(d.appeal.subCategory).enableEdit);
      }
    },
    async approveConfirm() {
      try {
        this.isLoading = true;
        // const approve = this.selected.map(async item => {
        //   await this.$store.dispatch("approveTask/approveApproveTask", {
        //     id: item.objectId
        //   });
        // });
        // await Promise.all(approve);
        for (const item of this.selected) {
          await this.$store.dispatch("approveTask/approveApproveTask", {
            id: item.objectId
          });
        }
        this.$toast.show({
          content: this.$t('task.approve_appeal_list', { count: this.selected.length }),
          color: "success"
        });
        this.selected = [];
        this.isConfirm = false;
        this.$emit("onInit", true);
        this.isLoading = false;
      } catch (e) {
        this.selected = [];
        this.isLoading = false;
        this.isConfirm = false;
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
      }
    },
    async rejectConfirm({ note }) {
      try {
        this.isLoading = true;
        const approve = this.selected.map(async item => {
          await this.$store.dispatch("approveTask/rejectApproveTask", {
            id: item.objectId,
            cancelledNote: note
          });
        });
        await Promise.all(approve);
        this.$toast.show({
          content: this.$t('task.not_approve_appeal_list', { count: this.selected.length }),
          color: "success"
        });
        this.selected = [];
        this.isCancel = false;
        this.$emit("onInit", true);
        this.isLoading = false;
      } catch (e) {
        this.selected = [];
        this.isLoading = false;
        this.isCancel = false;
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
      }
    },
    async approveConfirmIn() {
      this.selected = [this.currentApproveTask];
      await this.approveConfirm();
      this.isAppeal = false;
    },
    async rejectConfirmIn({ note }) {
      this.selected = [this.currentApproveTask];
      await this.rejectConfirm({ note });
      this.isAppeal = false;
    },
    exportSettingTask() {
      try {
        ExportSettingTask.exportSettingTaskByMarket(this.currentSettingTasks);
      } catch (error) {
        this.isError = true;
      }
    },
    async getInvoiceById(invoiceId) {
      await this.$store.dispatch("invoice/getInvoiceContract", {
        invoiceId,
        marketId: this.marketId
      });
    },
    async getContractsByCustomer() {
      this.currentAreas = [];
      this.currentContracts = [];
      this.isLoadAreas = true;
      try {
        for (const contract of this.form.contracts) {
          if (contract.isActive) {
            this.currentContracts.push(contract);
          }
          for (let area of contract.areas) {
            if (area.isOccupied || true) {
              if (!this.currentAreas) this.currentAreas = [];
              area.text = `${area.name || ""} ${!contract.isActive
                ? `(${this.$t('contract.close_rental_contract')})` : area.closeContractAt
                  ? `(${this.$t('area.close_contract')})` : area.isOccupied
                  ? `(${this.$t('customer.in_rental_agreement')})`
                  : `(${this.$t('customer.rental_agreement_expired')})`
                }`;
                
              this.currentAreas.push(area);
            }
          }
        }
        this.isLoadAreas = false;
      } catch (e) {
        this.isLoadAreas = false;
      }
    },
    momentToDate(date, format = "datetime") {
      let res = "";
      let formatDate = "DD MMM YYYY, hh:mm " + this.$t('timeunit.minute.short');
      if (format == "date") formatDate = "DD MMM YYYY";
      if (format == "datetimesec") formatDate = "DD MMM YYYY, HH:mm:ss";
      if (date?.iso) res = this.$moment(date.iso).format(formatDate);
      else if (date) res = this.$moment(date).format(formatDate);
      else res = "-";
      return res;
    },
    fullName(customer) {
      let fullname = "";
      if (customer) {
        fullname = `${customer.title || ""} ${customer.firstName ||
          "-"} ${customer.lastName || "-"}`;
      }
      if (!fullname) fullname = this.$t('not_specified');
      return fullname;
    },
    statusInvoice(invoice) {
      if (invoice.isPaid) {
        return this.$t('payment.already_paid');
      } else if (invoice.isSent) {
        return this.$t('payment.pending');
      } else if (invoice.documentId) {
        return this.$t('bill.edit_bill');
      } else {
        return this.$t('payment.wait_approval');
      }
    },
    checkPermission(subCategory) {
      let res = { enableEdit: false, enableSend: false };
      if (this.admin) {
        res.enableEdit = true;
        res.enableSend = true;
      }
      if (
        this.employee &&
        this.employee.enableAppealObject &&
        subCategory &&
        this.employee.enableAppealObject[subCategory]
      ) {
        res = this.employee.enableAppealObject[subCategory];
      }
      return res;
    },
    async loadContractDocuments(contractId) {
      let resContractDocument = []
      if (contractId) {
        this.isLoadContractDocument = true
        resContractDocument = await this.getContractDocuments({
          contractId: contractId,
          isRenewContract: true
        });
        this.isLoadContractDocument = false
      }
      return resContractDocument
    },
    contractDocumentDialog(e, contractId) {
      this.contractId = contractId
      this.contractDocumentId = e.objectId;
      this.isContractDocument = true;
    },
    tempContractsDocumentDialog(e, isDisable = false) {
      if (isDisable) {
        this.contractDocument = e;
      } else {
        this.contractDocument = null;
      }
      this.isContractDocumentDisable = isDisable || false;
      this.isTempContractDocument = true;
    },
    diffDays() {
      let days = 0;
      let minutes = 0;
      if (this.form.requestData.startDate && this.form.requestData.endDate) {
        minutes =
          this.$moment(this.form.requestData.endDate, "YYYY-MM-DD").diff(
            this.$moment(this.form.requestData.startDate, "YYYY-MM-DD"),
            "minutes"
          ) || 0;
        days = Math.ceil(minutes / (24 * 60)) + 1;
      }
      return days;
    },
    dayMonthYearText() {
      let days = 0;
      let months = 0;
      let years = 0;
      let text = "";
      if (this.form.requestData.startDate && this.form.requestData.endDate) {
        let a = this.$moment(this.form.requestData.endDate, "YYYY-MM-DD").endOf("day");
        let b = this.$moment(this.form.requestData.startDate, "YYYY-MM-DD").startOf("day");
        a.add(1, "days");
        years = a.diff(b, "year");
        b.add(years, "years");
        months = a.diff(b, "months");
        b.add(months, "months");
        days = a.diff(b, "days");
      }
      if (years) {
        text += `${years} ${this.$t('year')} `;
      }
      if (months) {
        text += `${months} ${this.$t('month')} `;
      }
      if (days) {
        text += `${days} ${this.$t('day')}`;
      }
      return text;
    },
    editSuspendDays(value) {
      let days = parseFloat(value);
      if (days && days > -1) {
        days--;
        let momentStartDate = this.$moment(this.form.requestData.startDate, "YYYY-MM-DD");
        momentStartDate.add(days, "days");
        this.form.requestData.endDate = momentStartDate.format("YYYY-MM-DD");
      }
    },
    editEndDate() {
      this.form.requestData.suspendDays = this.diffDays();
    },
  }
};
</script>
<style lang="scss" scoped>
.product-in-areas-box-list {
  margin-bottom: 20px;

  .product-in-areas-box-header {
    font-size: 20px;
    margin-bottom: 5px;
  }

  .product-in-areas-box {
    padding: 0px 15px;
    border: 1px solid rgba(128, 128, 128, 0.514);
    border-radius: 5px;

    .product-in-areas-items {
      margin: 15px 0;
      padding-bottom: 15px;
      border-bottom: 1px solid rgba(128, 128, 128, 0.514);

      .product-in-areas-item-header {
        // font-weight: bold;
      }

      .no-data {
        padding-left: 10px;
        margin-bottom: 5px;
      }
    }

    .product-in-areas-items:last-child {
      border-bottom: none;
      padding-bottom: 0px;
    }
  }
}

.renew-contract-box {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid rgb(211, 211, 211);
  border-radius: 10px;
  margin-bottom: 15px;
  padding: 10px 15px;

  &.new {
    border: 2px solid #fbae43;
  }

  &.new-now {
    border: 2px solid var(--v-success-base);

  }

  .sub-title {
    font-size: 18px;
    padding-bottom: 0;
    display: flex;
    align-items: center;
  }

  .input-slot {
    background-color: #f5f5f5;
    border-color: #f5f5f5;
    border-radius: 4px;
    padding: 12px;
    margin: 0;
    font-size: 18px;
  }

  @for $i from 1 through 5 {
    $colum-size : 100% / ($i);

    .col-#{($i)} {
      width: $colum-size;
      max-width: $colum-size;
      flex-basis: $colum-size;
      min-width: 200px;
    }
  }
}

.text-detail {
  color: black;
  min-height: 100px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.box-radio {
  padding: 15px 10px;
  border: 1px solid #A9A9A9;
  border-radius: 8px;
  width: 100%;
  &.v-item--active {
    border: 1px solid var(--v-fontPrimary-base) !important;
    opacity: 1 !important;
    background: #E8F5E9 !important;
    color: #000 !important;
    ::v-deep .v-icon {
      color: var(--v-fontPrimary-base) !important;
    }
  }

  &.v-radio--is-disabled {
    border: 1px solid #A9A9A9;
    opacity: 1;
    cursor: not-allowed;
    pointer-events: none;
    background: #eee;
  }
}
.w-50{
  width: 50%;
}

</style>
